<div class="dashlet-flip__content-wrapper dashletFlip__back">
  <pp-dashlet-head
    [ppAssetId]="ppAssetId()"
    [ppDashlet]="ppDashlet()"
    (ppToggleFlip)="flipDashlet()"
    (ppDashletChange)="onDashletNameChange($event)"
    (ppSave)="apply()"
  >
  </pp-dashlet-head>

  <div
    class="dashletFlip__container"
    [class.dashletFlip__container--active]="ppFlipped()"
    #dashletFlipContainer
  >
    @if (
      ppDashlet().period &&
      ppDashlet().name !== dashletTypes.CURRENT_STATUS &&
      ppDashlet().name !== dashletTypes.CURRENT_PRIORITY
    ) {
      <pp-dashlet-period-select
        [ppDashlet]="ppDashlet()"
        [(ppPeriod)]="period"
      ></pp-dashlet-period-select>
    }

    @if (!ppAssetId()) {
      <pp-dashlet-workspace-select
        [ppDashlet]="ppDashlet()"
        [(ppSiteRange)]="siteRange"
      ></pp-dashlet-workspace-select>
    }

    @if (ppAssetId()) {
      <pp-dashlet-workspace-select-multiple
        [ppDashlet]="ppDashlet()"
        [ppDefaultWorkspaces]="ppDefaultWorkspaces()"
        [ppLimitedWorkspaces]="
          ppDashlet().name === dashletTypes.CURRENT_STACKED_STATUS ||
          ppDashlet().name === dashletTypes.COST_COMPARISON
        "
        [(ppSiteRange)]="siteRange"
      ></pp-dashlet-workspace-select-multiple>
    }
  </div>

  <div class="dashletFlip__footer">
    <pp-delete-button
      (mousedown)="$event.stopPropagation()"
      (ppAction)="removeDashlet()"
    ></pp-delete-button>

    <pp-button-modal-confirm
      ppDataTarget="Dashlet settings apply button"
      ppStyle="primary"
      (ppAction)="apply()"
    >
      {{ 'save' | ppTranslate }}
    </pp-button-modal-confirm>
  </div>
</div>
